import React, { useEffect, useState } from 'react'
import { useStore } from '../../../app/stores/store';
import { Activity } from '../../../app/models/activity';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { Button, ButtonGroup, ButtonOr, Form, Grid, Header, Input, Segment, Select, TextArea } from 'semantic-ui-react';
import { HFCServiceInfo, HFCServiceInfoInitialdata } from '../../../app/models/ReceivingDelivery';
import agent from '../../../app/api/agent';
import { toast } from 'react-toastify';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import { historyInitialState } from '../../../app/models/history';


function AssignTask() {
    const{activityStore, userStore, dashboardStore}= useStore()
    const [pageNumber, setPageNumber] = useState(1);
    const[selectedService, setSelectedService]=useState<HFCServiceInfo>(HFCServiceInfoInitialdata);
    const[userOptions, setUserOptions]= useState<{ key: string; value: string; text: string }[]>([]);
    const[selectedUser, setSelectedUser]= useState<string>('')
    const[mail, setMail]= useState<string[]>([])

    // const [postsPerPage, setPostsPerPage] = useState<number>(5);    
    const postsPerPage = 5
    const userDisable = selectedUser===""


    

    useEffect(() => {
        const fetchData = async () => {
            const pageSize = 5;
            await activityStore.HFCAssignTaskloadActivitiesPagination(pageNumber, userStore?.user!.id, pageSize, []);
            const res = await agent.HFC.HFCUSerRole();
            const tempOptions = res.data?.map((user:any) => {
                return {
                  key: user,
                  value: user,
                  text: user,
                };
              });
            setUserOptions(tempOptions);
        };
    
        fetchData();
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        const fetchData = async () => {
          if (activityStore.selectedService && 
              dashboardStore.dashboard.valueForL3Orders === "Assign Task to Personnal") {
                setSelectedService(activityStore.selectedService);
          }
        };
      
        fetchData();
      // eslint-disable-next-line
      }, [activityStore.selectedService]);
    
      useEffect(()=>{
        setSelectedService(HFCServiceInfoInitialdata);
      },[])

      const handleCancel=()=>{
        setSelectedService(HFCServiceInfoInitialdata)
        setSelectedUser('')
      }


      const handleSelect = async(e:any, data:any)=>{
      
        const selectedValue = data.value;
        setSelectedUser(selectedValue)
        await userStore.loadUsers()
        const email = userStore.userList.filter((user:any)=>{
        return user.roleName === selectedValue
        })
       const selectedmail = email.map((usrmail:any )=>{
          return usrmail.email
       })
       setMail(selectedmail)
      }

      const handleAssign=async()=>{
        const res = await agent.HFC.HFCAssignUser(selectedService.id, selectedUser)
        toast.success(res.data)

        setSelectedService(HFCServiceInfoInitialdata)
        setSelectedUser('')
        dashboardStore.dashboard.valueForL3Orders="Services"
        activityStore.selectedService=HFCServiceInfoInitialdata
        const receivingPayload = {
          ...historyInitialState,
          itemId: selectedService.asset_ID,
          status: `${userStore.user?.displayName} has assigned the ${selectedUser} to process the service request for the asset "${selectedService.title}"`,
          dateTime: new Date().toISOString(),
          trackerFromTime: new Date().toISOString(),
      }
      await agent.HFC.HFCaddHistory(receivingPayload)
        sendRespectiveEmail(
          'Notification',
          selectedService.title,
          'Assign Task',
          '',
          ` Task Assigned successfully on`,
          `${mail}`,
          ''
        );
      }
  
  
    const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
    const tableData: Activity[] = [];

    activityStore.activitiesByDate?.forEach((a: any) => {
        // isMaster
        delete a?.isMaster;
        // eslint-disable-next-line
        delete a?.sections_Multiple_From;
        delete a?.sections_From;
        delete a?.synopsis;
    
        tableData?.push({
          ...a,
          //  movementdate:userReadableDateFormat(a.movementdate),
          //  movement_Time:userReadableDateFormat(a.movement_Time),
          //  maintenance:userReadableDateFormat(a.maintenance),
          //  receivingdate:userReadableDateFormat(a.receivingdate),
          //  status_Time: userReadableDateFormat(a.status_Time),
          //  itemCreatedAt:userReadableDateFormat(a.itemCreatedAt)
        });
      });
      const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
      const MainFilter =
        dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
          ? createOrderFilter
          : tableData;
    
      const removeCol =
        'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,inactive,isgoing,ishost,clearedon';
      const assettable = JSON.parse(JSON.stringify(MainFilter));
      assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

      const paginateFunction = (e: number) => {
        const resultArray = Object.entries(dashboardStore.dashboard.searchfilterparams).map(([header, searchValue]) => ({
          header,
          searchValue
        }));
        if (
          !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
          Object.values(dashboardStore.dashboard.searchfilterparams).every(
            (o) => o !== '',
          ) &&
          dashboardStore.dashboard.orderData === '' &&
          dashboardStore.dashboard.orderName === ''
        ) {
          activityStore.HFCAssignsearchListItems(resultArray,
            e,
            postsPerPage) 
        } else if (
          dashboardStore.dashboard.orderData !== '' &&
          dashboardStore.dashboard.orderName !== ''
        ) {
          activityStore.sortListItems(
            dashboardStore.dashboard.orderName,
            dashboardStore.dashboard.orderData,
            e,
            postsPerPage,
          ); 
        } else {
          // console.log(e,userID,postsPerPage,[])
          activityStore.HFCShipperloadActivitiesPagination(e, userID, postsPerPage);
        }
        dashboardStore.setTagPageNumFunc(e);
        setPageNumber(e);
      };
      const searchFunction = (column: any, order: any) => {
        console.log(order, column);
      };
  return (
    <div>
    <div id="parent-grid-receiving" className={dashboardStore.dashboard.rowIdForDynamicTable === -1 ? "ele-disable" : ""}>
    <Segment clearing className="register-form-segment ui clearing segment register-form-segment">
    <Form>
        <Header
            clearing
            icon="edit"
            size="huge"
            dividing
            as="h1"
            content="Assign Task to Personnal"
            sub
            color="grey"
        />
        <Grid stretched columns={4} style={{marginTop: "10px"}}>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Title</label>
                <Input
                name="title"
                placeholder="Title"
                value={selectedService.title}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Asset Id</label>
                <Input
                name="asset_Id"
                placeholder="Asset Id"
                value={selectedService.asset_ID}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Print #</label>
                <Input
                name="print"
                placeholder="Print"
                value={selectedService.print}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Vault</label>
                <Input
                name="vault"
                placeholder="Vault"
                value={selectedService.vault}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        <Grid stretched columns={4} style={{marginTop: "10px"}}>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Shipping Date</label>
                <Input
                name="shipping_Date"
                placeholder="Shipping Date"
                value={selectedService.shipping_Date}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Return Date</label>
                <Input
                name="return_Date"
                placeholder="Return Date"
                value={selectedService.return_Date}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Where it Come From</label>
                <Input
                name="location"
                placeholder="Location"
                value={selectedService.shipping_Location ?? selectedService.theatreName}
                />
            </Form.Field>
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Address</label>
            <Input
                name="address"
                placeholder="Address"
                value={selectedService.address ?? selectedService.theatreAddressLine1}
                />
            </Form.Field>
          </Grid.Column>
        </Grid>
        <Grid stretched columns={3}>
            <Grid.Column>
                <Form.Field
                control={Input}
                label="Account" 
                value={selectedService.account ?? selectedService.carrierAccount}
                search
                clearable
                placeholder="Account"/>
            </Grid.Column>
            <Grid.Column>
                <Form.Field
                control={Input}
                value={selectedService.requested_By}
                label="Requested By" 
                search
                clearable
                placeholder="Requested By"/>
            </Grid.Column>
            <Grid.Column>
                <Form.Field
                control={Input}
                value={selectedService.requester_Email}
                label="Requester Email" 
                search
                clearable
                placeholder="Requester Email"/>
            </Grid.Column>
        </Grid>
        <Grid stretched columns={2}>
          <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Assets Associated  W/Title & Asset Id</label>
            <TextArea value={selectedService.assets_Associated_with_Title_and_Asset_ID}/>
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Notes</label>
            <TextArea value={selectedService.notes}/>
            </Form.Field>
          </Grid.Column>
        </Grid>
        <Grid stretched columns={2}>
          <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Service</label>
            <Input
                name="service"
                placeholder="Service"
                value={selectedService.service}
            />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field
            options={userOptions}
            control={Select}
            label="Assign Task To Personnal" 
            search
            clearable
            placeholder="Assign Task To Personnal"
            onChange={handleSelect}
            value={selectedUser}
            />
          </Grid.Column>
        </Grid>
        <div style={{textAlign: 'right', marginTop:'20px'}}>
        <ButtonGroup>
            <Button onClick={handleCancel}>Cancel</Button>
            <ButtonOr/>
            <Button disabled={userDisable} onClick={handleAssign} color='green'>Assign</Button>
        </ButtonGroup>
        </div>
    </Form>
    </Segment>
    </div>
        <DynamicTableComponent data={assettable} name={'HFCShipper'} actiontype={''} pageFunc={paginateFunction} pageNumData={pageNumber} searchFuncData={searchFunction}/>
    </div>
  )
}

export default observer(AssignTask)